export default function ({ store, redirect, app, error }) {
	//return redirect('/')
	error({ statusCode: 404 })
}